import type { IncidentFieldRule } from './types';
import { whenPathIncludes } from './conditions';
import { actionableObservationEnumsTypeOfUnsafeBehaviourOptionEnum } from '@/gen/types/ActionableObservationEnumsTypeOfUnsafeBehaviourOption';

/**
 * Field rules for Actionable Observation incident create form.
 *
 * - Show `typeOfUnsafeBehaviourExplanation` only when the 'Other' option is selected
 *   in `typeOfUnsafeBehaviour`.
 */
export const actionableObservationFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What kind of observation is this?',
        description: 'Select the type of actionable observation.',
        order: 80,
    },
    {
        key: 'observationCategory',
        label: 'Which category does this observation fall under?',
        description: 'Select the category that best fits this observation.',
        order: 90,
    },
    {
        key: 'typeOfUnsafeBehaviour',
        label: 'What type of unsafe behaviour or hazardous condition was observed?',
        description: 'Select the type, e.g. missing PPE, unsafe act, hazardous condition.',
        order: 100,
    },
    // Explanation field should only be visible (and required) when 'Other' is selected
    {
        key: 'typeOfUnsafeBehaviourExplanation',
        label: 'Please describe the unsafe behaviour observed',
        description: 'Describe the unsafe behaviour or hazardous condition and its context.',
        order: 110,
        kind: 'textarea',
        visibleWhen: whenPathIncludes(
            'typeOfUnsafeBehaviour',
            actionableObservationEnumsTypeOfUnsafeBehaviourOptionEnum.Other,
        ),
        requiredWhen: whenPathIncludes(
            'typeOfUnsafeBehaviour',
            actionableObservationEnumsTypeOfUnsafeBehaviourOptionEnum.Other,
        ),
    },
];
